import typeOf from './typeOf';

const lct = {
    parse(str) {
        if (str.charAt(0) === '#' || str.charAt(0) === '?') {
            str = str.substring(1);
        }

        let array = str.split('&');
        let ob = {};

        array.map((item) => {
            let itemArray = item.split('=');

            if (typeOf.isNumeric(itemArray[1])) {
                itemArray[1] = +itemArray[1];
            }

            ob[itemArray[0]] = decodeURIComponent(itemArray[1]);
        });

        return ob;
    },

    stringify(ob) {
        let str = '';

        for (let key in ob) {
            str += `&${key}=${ob[key]}`;
        }

        return str.substring(1);
    }
};

export default lct;
